/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnticipatoryPartnerUser,
  AnticipatoryPartnerUserError,
  AnticipatoryPartnerUserRequest,
  LicenseOrdering,
  LicensedStatus,
  ManagementActionCategory,
  ManagementActionOrdering,
  ManagementActionType,
  MinimalTenant,
  PaginatedLicenseList,
  PaginatedManagementActionList,
  PaginatedPartnerGroupList,
  PaginatedTenantListList,
  PaginatedTenantRenewalsList,
  PaginatedTenantSeatList,
  PartnerGroup,
  PartnerGroupOrdering,
  PartnerUser,
  PartnerUserError,
  PartnerUserRequest,
  PatchedPartnerUserRequest,
  ProductType,
  Region,
  RenewalsOrdering,
  SeatOrdering,
  TenantOrdering,
  TenantType,
  TenantsStats,
} from '../models';
import {
    AnticipatoryPartnerUserFromJSON,
    AnticipatoryPartnerUserToJSON,
    AnticipatoryPartnerUserErrorFromJSON,
    AnticipatoryPartnerUserErrorToJSON,
    AnticipatoryPartnerUserRequestFromJSON,
    AnticipatoryPartnerUserRequestToJSON,
    LicenseOrderingFromJSON,
    LicenseOrderingToJSON,
    LicensedStatusFromJSON,
    LicensedStatusToJSON,
    ManagementActionCategoryFromJSON,
    ManagementActionCategoryToJSON,
    ManagementActionOrderingFromJSON,
    ManagementActionOrderingToJSON,
    ManagementActionTypeFromJSON,
    ManagementActionTypeToJSON,
    MinimalTenantFromJSON,
    MinimalTenantToJSON,
    PaginatedLicenseListFromJSON,
    PaginatedLicenseListToJSON,
    PaginatedManagementActionListFromJSON,
    PaginatedManagementActionListToJSON,
    PaginatedPartnerGroupListFromJSON,
    PaginatedPartnerGroupListToJSON,
    PaginatedTenantListListFromJSON,
    PaginatedTenantListListToJSON,
    PaginatedTenantRenewalsListFromJSON,
    PaginatedTenantRenewalsListToJSON,
    PaginatedTenantSeatListFromJSON,
    PaginatedTenantSeatListToJSON,
    PartnerGroupFromJSON,
    PartnerGroupToJSON,
    PartnerGroupOrderingFromJSON,
    PartnerGroupOrderingToJSON,
    PartnerUserFromJSON,
    PartnerUserToJSON,
    PartnerUserErrorFromJSON,
    PartnerUserErrorToJSON,
    PartnerUserRequestFromJSON,
    PartnerUserRequestToJSON,
    PatchedPartnerUserRequestFromJSON,
    PatchedPartnerUserRequestToJSON,
    ProductTypeFromJSON,
    ProductTypeToJSON,
    RegionFromJSON,
    RegionToJSON,
    RenewalsOrderingFromJSON,
    RenewalsOrderingToJSON,
    SeatOrderingFromJSON,
    SeatOrderingToJSON,
    TenantOrderingFromJSON,
    TenantOrderingToJSON,
    TenantTypeFromJSON,
    TenantTypeToJSON,
    TenantsStatsFromJSON,
    TenantsStatsToJSON,
} from '../models';

export interface PartnerActionsListRequest {
    partnerId: string;
    action?: ManagementActionType;
    category?: ManagementActionCategory;
    ordering?: ManagementActionOrdering | `-${ManagementActionOrdering}`;
    page?: number;
    pageSize?: number;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerLicenseListRequest {
    partnerId: string;
    activationDateAfter?: Date;
    activationDateBefore?: Date;
    autoRenew?: boolean;
    edition?: string;
    expiryDateAfter?: Date;
    expiryDateBefore?: Date;
    isSubscription?: boolean;
    licenseNumber?: string;
    ordering?: LicenseOrdering | `-${LicenseOrdering}`;
    page?: number;
    pageSize?: number;
    product?: Array<string>;
    productSku?: Array<string>;
    productType?: ProductType;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerListRequest {
    id?: string;
    name?: string;
    ordering?: PartnerGroupOrdering | `-${PartnerGroupOrdering}`;
    page?: number;
    pageSize?: number;
}

export interface PartnerLookupRetrieveRequest {
    lookup: string;
}

export interface PartnerPendingTenantListRequest {
    partnerId: string;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerRenewalsListRequest {
    partnerId: string;
    ordering?: RenewalsOrdering | `-${RenewalsOrdering}`;
    page?: number;
    pageSize?: number;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerRetrieveRequest {
    id: string;
}

export interface PartnerSeatListRequest {
    partnerId: string;
    directLicensedEditions?: string;
    firstSeenAfter?: Date;
    firstSeenBefore?: Date;
    licenseNumbers?: string;
    licensedEditions?: string;
    licensedStatus?: LicensedStatus;
    name?: string;
    ordering?: SeatOrdering | `-${SeatOrdering}`;
    page?: number;
    pageSize?: number;
    serial?: string;
    tenant?: string;
    tenantType?: TenantType;
    unlicensedEditions?: string;
    userFacingId?: string;
}

export interface PartnerTenantListRequest {
    partnerId: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    edition?: string;
    editions?: Array<string>;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantOrdering | `-${TenantOrdering}`;
    page?: number;
    pageSize?: number;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    region?: Region;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerTenantStatsRetrieveRequest {
    partnerId: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    edition?: string;
    editions?: Array<string>;
    email?: string;
    fullManageability?: boolean;
    ordering?: TenantOrdering | `-${TenantOrdering}`;
    partner?: string;
    productType?: ProductType;
    products?: Array<string>;
    region?: Region;
    tenant?: string;
    tenantType?: TenantType;
}

export interface PartnerUserCreateRequest {
    partnerId: string;
    anticipatoryPartnerUserRequest: AnticipatoryPartnerUserRequest;
}

export interface PartnerUserDestroyRequest {
    id: string;
    partnerId: string;
}

export interface PartnerUserListRequest {
    partnerId: string;
}

export interface PartnerUserPartialUpdateRequest {
    id: string;
    partnerId: string;
    patchedPartnerUserRequest?: PatchedPartnerUserRequest;
}

export interface PartnerUserRetrieveRequest {
    id: string;
    partnerId: string;
}

export interface PartnerUserUpdateRequest {
    id: string;
    partnerId: string;
    partnerUserRequest: PartnerUserRequest;
}

/**
 * 
 */
export class PartnerApi extends runtime.BaseAPI {

    /**
     */
    async partnerActionsListRaw(requestParameters: PartnerActionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedManagementActionList>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerActionsList.');
        }

        const queryParameters: any = {};

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/actions/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedManagementActionListFromJSON(jsonValue));
    }

    /**
     */
    async partnerActionsList(requestParameters: PartnerActionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedManagementActionList> {
        const response = await this.partnerActionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerLicenseListRaw(requestParameters: PartnerLicenseListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedLicenseList>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerLicenseList.');
        }

        const queryParameters: any = {};

        if (requestParameters.activationDateAfter !== undefined) {
            queryParameters['activation_date_after'] = (requestParameters.activationDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.activationDateBefore !== undefined) {
            queryParameters['activation_date_before'] = (requestParameters.activationDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.autoRenew !== undefined) {
            queryParameters['auto_renew'] = requestParameters.autoRenew;
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.expiryDateAfter !== undefined) {
            queryParameters['expiry_date_after'] = (requestParameters.expiryDateAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.expiryDateBefore !== undefined) {
            queryParameters['expiry_date_before'] = (requestParameters.expiryDateBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.isSubscription !== undefined) {
            queryParameters['is_subscription'] = requestParameters.isSubscription;
        }

        if (requestParameters.licenseNumber !== undefined) {
            queryParameters['license_number'] = requestParameters.licenseNumber;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.product) {
            queryParameters['product'] = requestParameters.product;
        }

        if (requestParameters.productSku) {
            queryParameters['product_sku'] = requestParameters.productSku;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/license/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLicenseListFromJSON(jsonValue));
    }

    /**
     */
    async partnerLicenseList(requestParameters: PartnerLicenseListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedLicenseList> {
        const response = await this.partnerLicenseListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerListRaw(requestParameters: PartnerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPartnerGroupList>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/partner/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPartnerGroupListFromJSON(jsonValue));
    }

    /**
     */
    async partnerList(requestParameters: PartnerListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPartnerGroupList> {
        const response = await this.partnerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerLookupRetrieveRaw(requestParameters: PartnerLookupRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerGroup>> {
        if (requestParameters.lookup === null || requestParameters.lookup === undefined) {
            throw new runtime.RequiredError('lookup','Required parameter requestParameters.lookup was null or undefined when calling partnerLookupRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/partner/lookup/{lookup}/`.replace(`{${"lookup"}}`, encodeURIComponent(String(requestParameters.lookup))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerGroupFromJSON(jsonValue));
    }

    /**
     */
    async partnerLookupRetrieve(requestParameters: PartnerLookupRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerGroup> {
        const response = await this.partnerLookupRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerPendingTenantListRaw(requestParameters: PartnerPendingTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MinimalTenant>>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerPendingTenantList.');
        }

        const queryParameters: any = {};

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/pending-tenant/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MinimalTenantFromJSON));
    }

    /**
     */
    async partnerPendingTenantList(requestParameters: PartnerPendingTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MinimalTenant>> {
        const response = await this.partnerPendingTenantListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerRenewalsListRaw(requestParameters: PartnerRenewalsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantRenewalsList>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerRenewalsList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/renewals/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantRenewalsListFromJSON(jsonValue));
    }

    /**
     */
    async partnerRenewalsList(requestParameters: PartnerRenewalsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantRenewalsList> {
        const response = await this.partnerRenewalsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerRetrieveRaw(requestParameters: PartnerRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partnerRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/partner/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerGroupFromJSON(jsonValue));
    }

    /**
     */
    async partnerRetrieve(requestParameters: PartnerRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerGroup> {
        const response = await this.partnerRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerSeatListRaw(requestParameters: PartnerSeatListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantSeatList>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerSeatList.');
        }

        const queryParameters: any = {};

        if (requestParameters.directLicensedEditions !== undefined) {
            queryParameters['direct_licensed_editions'] = requestParameters.directLicensedEditions;
        }

        if (requestParameters.firstSeenAfter !== undefined) {
            queryParameters['first_seen_after'] = (requestParameters.firstSeenAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.firstSeenBefore !== undefined) {
            queryParameters['first_seen_before'] = (requestParameters.firstSeenBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.licenseNumbers !== undefined) {
            queryParameters['license_numbers'] = requestParameters.licenseNumbers;
        }

        if (requestParameters.licensedEditions !== undefined) {
            queryParameters['licensed_editions'] = requestParameters.licensedEditions;
        }

        if (requestParameters.licensedStatus !== undefined) {
            queryParameters['licensed_status'] = requestParameters.licensedStatus;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.serial !== undefined) {
            queryParameters['serial'] = requestParameters.serial;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        if (requestParameters.unlicensedEditions !== undefined) {
            queryParameters['unlicensed_editions'] = requestParameters.unlicensedEditions;
        }

        if (requestParameters.userFacingId !== undefined) {
            queryParameters['user_facing_id'] = requestParameters.userFacingId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/seat/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantSeatListFromJSON(jsonValue));
    }

    /**
     */
    async partnerSeatList(requestParameters: PartnerSeatListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantSeatList> {
        const response = await this.partnerSeatListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerTenantListRaw(requestParameters: PartnerTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTenantListList>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerTenantList.');
        }

        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.editions) {
            queryParameters['editions'] = requestParameters.editions;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/tenant/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTenantListListFromJSON(jsonValue));
    }

    /**
     */
    async partnerTenantList(requestParameters: PartnerTenantListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTenantListList> {
        const response = await this.partnerTenantListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerTenantStatsRetrieveRaw(requestParameters: PartnerTenantStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantsStats>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerTenantStatsRetrieve.');
        }

        const queryParameters: any = {};

        if (requestParameters.createdAtAfter !== undefined) {
            queryParameters['created_at_after'] = (requestParameters.createdAtAfter as any).toISOString().substr(0,10);
        }

        if (requestParameters.createdAtBefore !== undefined) {
            queryParameters['created_at_before'] = (requestParameters.createdAtBefore as any).toISOString().substr(0,10);
        }

        if (requestParameters.edition !== undefined) {
            queryParameters['edition'] = requestParameters.edition;
        }

        if (requestParameters.editions) {
            queryParameters['editions'] = requestParameters.editions;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.fullManageability !== undefined) {
            queryParameters['full_manageability'] = requestParameters.fullManageability;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.partner !== undefined) {
            queryParameters['partner'] = requestParameters.partner;
        }

        if (requestParameters.productType !== undefined) {
            queryParameters['product_type'] = requestParameters.productType;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.region !== undefined) {
            queryParameters['region'] = requestParameters.region;
        }

        if (requestParameters.tenant !== undefined) {
            queryParameters['tenant'] = requestParameters.tenant;
        }

        if (requestParameters.tenantType !== undefined) {
            queryParameters['tenant_type'] = requestParameters.tenantType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/tenant/stats/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantsStatsFromJSON(jsonValue));
    }

    /**
     */
    async partnerTenantStatsRetrieve(requestParameters: PartnerTenantStatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantsStats> {
        const response = await this.partnerTenantStatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerUserCreateRaw(requestParameters: PartnerUserCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnticipatoryPartnerUser>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserCreate.');
        }

        if (requestParameters.anticipatoryPartnerUserRequest === null || requestParameters.anticipatoryPartnerUserRequest === undefined) {
            throw new runtime.RequiredError('anticipatoryPartnerUserRequest','Required parameter requestParameters.anticipatoryPartnerUserRequest was null or undefined when calling partnerUserCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnticipatoryPartnerUserRequestToJSON(requestParameters.anticipatoryPartnerUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnticipatoryPartnerUserFromJSON(jsonValue));
    }

    /**
     */
    async partnerUserCreate(requestParameters: PartnerUserCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnticipatoryPartnerUser> {
        const response = await this.partnerUserCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerUserDestroyRaw(requestParameters: PartnerUserDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partnerUserDestroy.');
        }

        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async partnerUserDestroy(requestParameters: PartnerUserDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.partnerUserDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async partnerUserListRaw(requestParameters: PartnerUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerUser>>> {
        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/`.replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerUserFromJSON));
    }

    /**
     */
    async partnerUserList(requestParameters: PartnerUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerUser>> {
        const response = await this.partnerUserListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerUserPartialUpdateRaw(requestParameters: PartnerUserPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partnerUserPartialUpdate.');
        }

        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPartnerUserRequestToJSON(requestParameters.patchedPartnerUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerUserFromJSON(jsonValue));
    }

    /**
     */
    async partnerUserPartialUpdate(requestParameters: PartnerUserPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerUser> {
        const response = await this.partnerUserPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerUserRetrieveRaw(requestParameters: PartnerUserRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partnerUserRetrieve.');
        }

        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerUserFromJSON(jsonValue));
    }

    /**
     */
    async partnerUserRetrieve(requestParameters: PartnerUserRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerUser> {
        const response = await this.partnerUserRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnerUserUpdateRaw(requestParameters: PartnerUserUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerUser>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partnerUserUpdate.');
        }

        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) {
            throw new runtime.RequiredError('partnerId','Required parameter requestParameters.partnerId was null or undefined when calling partnerUserUpdate.');
        }

        if (requestParameters.partnerUserRequest === null || requestParameters.partnerUserRequest === undefined) {
            throw new runtime.RequiredError('partnerUserRequest','Required parameter requestParameters.partnerUserRequest was null or undefined when calling partnerUserUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/customerapi/v2/partner/{partner_id}/user/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"partner_id"}}`, encodeURIComponent(String(requestParameters.partnerId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerUserRequestToJSON(requestParameters.partnerUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerUserFromJSON(jsonValue));
    }

    /**
     */
    async partnerUserUpdate(requestParameters: PartnerUserUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerUser> {
        const response = await this.partnerUserUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
